import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: '100%',
        height: '100%',
    },
    sideBarWrapper: {
        color: theme.palette.background.default,
        lineHeight: theme.typography.pxToRem(28),
        boxSizing: 'border-box',
        padding: theme.spacing(6, 12, 0, 12),
        background: theme.palette.secondary.main,
        width: 450,
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(6, 6, 0, 6),
            width: 300,
        },
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(4, 6),
            width: '100%',
        },
    },
    actHealthColor: {
        background: theme.palette.actHealth.main,
    },
    youAreWrapper: {
        margin: theme.spacing(8, 0),
        [theme.breakpoints.down('xs')]: {
            margin: theme.spacing(4, 0),
        },
    },
    formWrapper: {
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(4, 0),
        },
    },
}));
